import { type IPlaybookPage } from "../../app-utils/playbook.js";
import { type Attribute, type RawAttributeDefault, type SampleType } from "../../graphql.js";
import { SelectorIcons } from "../../settings/assets-settings.js";
import PlaybookWizard from "../playbooks/PlaybookWizard.js";
import AddSampleTypeScreen from "./AddSampleTypeScreen.js";

export interface IAttributeWithDefault extends Attribute {
  attributeDefault?: Partial<RawAttributeDefault>;
}

export interface IAddSampleTypeDialogProps {
  title: string;
  sampleType?: SampleType; // editing case
  attributeDefaults?: Array<Partial<RawAttributeDefault>>; // editing case

  onApply: () => void;
  onClose: () => void;
}

const AddSampleTypeDialog = (props: IAddSampleTypeDialogProps) => {
  const sampleTypeDialogScreen: IPlaybookPage = {
    label: props.sampleType ? "Edit Sample Type Data" : "Enter Data for New Sample Type",
  };

  return (
    <PlaybookWizard
      title={props.title}
      steps={[sampleTypeDialogScreen]}
      mapStepToScreen={(p) => (
        <AddSampleTypeScreen
          playbookPage={p}
          attributeDefaults={props.attributeDefaults}
          sampleType={props.sampleType}
        />
      )}
      onClose={props.onClose}
      icon={SelectorIcons.CONFIG}
    />
  );
};

export default AddSampleTypeDialog;
